import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FileSystemProjectContractTerm } from 'shared/domains/apollo/generated/types';
export const getProjectContractTermLabels = () => ({
    [FileSystemProjectContractTerm.NotStarted]: t({
        message: 'Not started',
        comment: 'Project contract term - Not started',
    }),
    [FileSystemProjectContractTerm.Ongoing]: t({
        message: 'Ongoing',
        comment: 'Project contract term - Ongoing',
    }),
    [FileSystemProjectContractTerm.Terminated]: t({
        message: 'Terminated',
        comment: 'Project contract term - Terminated',
    }),
});
export const getProjectContractTermIcon = (contractTerm) => {
    const icons = {
        [FileSystemProjectContractTerm.NotStarted]: (<Falcon icon="circle-dot" $color="gray.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
        [FileSystemProjectContractTerm.Ongoing]: (<Falcon icon="circle-play" $color="blue.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
        [FileSystemProjectContractTerm.Terminated]: (<Falcon icon="circle-xmark" $color="red.500" sourceConfig={{ family: 'classic', style: 'solid' }}/>),
    };
    return icons[contractTerm];
};
export const getProjectContractTermAppearance = (contractTerm) => {
    const appearances = {
        [FileSystemProjectContractTerm.NotStarted]: 'secondary',
        [FileSystemProjectContractTerm.Ongoing]: 'info',
        [FileSystemProjectContractTerm.Terminated]: 'danger',
    };
    return appearances[contractTerm];
};
